
export const KeyFilter = {
    type_report : "type_report",
    department_id : "department_id",
    START_DATE : "startDate",
    END_DATE : "endDate",
}
